import React from "react";

import { HStack } from "@formant/ui/component/common/HStack";

import { track } from "../../analytics";
import { authStore } from "../../stores";
import { StandardButton } from "../common/StandardButton";
import styles from "./Account.scss";
import { AccountLink } from "./AccountLink";

export interface IAccountProps {
    onClose: () => void;
}

const onLogout = () => {
    track("Last online");
    authStore.logout();
    window.location.href = "/";
};

export const Account = (props: IAccountProps) => {
    const { onClose } = props;

    return (
        <HStack vAlign="center" className={styles.account}>
            <AccountLink onClose={onClose} />
            <StandardButton
                data-testid="sign-out-button"
                to="/"
                onClicked={onLogout}
            >
                Sign Out
            </StandardButton>
        </HStack>
    );
};
